// extracted by mini-css-extract-plugin
export default {"item":"RecentlyViewedCard_module-H5IM4SB6_item__uQz+p"};